import { render, staticRenderFns } from "./app-layout-setting.vue?vue&type=template&id=63081c12&"
import script from "./app-layout-setting.vue?vue&type=script&lang=js&"
export * from "./app-layout-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports